module.exports = "\n<span>\n    {{ title }}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/property/Title.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/property/Title.vue
// module chunks = 53